import {
  UpdateStaffMutationVariables,
  useFindUniqueStaffQuery,
  useUpdateStaffMutation,
} from "../../generated/graphql";
import { useToast } from "@chakra-ui/react";
import Loading from "../../components/loading/Loading";
import { Navigate, useNavigate } from "react-router-dom";
import Form from "./Form";

interface Props {
  id: string;
}

const Update: React.VFC<Props> = ({ id }) => {
  const [updateUser] = useUpdateStaffMutation();
  const navigation = useNavigate();
  const toast = useToast();

  const { loading, error, data } = useFindUniqueStaffQuery({
    variables: {
      where: {
        id,
      },
    },
    fetchPolicy: "network-only",
  });

  if (loading) {
    return <Loading />;
  }
  if (error) {
    return <Navigate to={"/user"} replace />;
  }

  const handleUpdateUser = async (data: UpdateStaffMutationVariables) => {
    try {
      await updateUser({
        variables: {
          ...data,
        },
      });

      return toast({
        status: "success",
        title: "Başarılı",
        description: "Yetkili güncellendi",
        duration: 1000,
        onCloseComplete: () => {
          return navigation("/customer");
        },
      });
    } catch (error: any) {
      console.log(error.message);
      return toast({
        status: "error",
        title: "Hata",
        description: error.message || "Bir hata oluştu",
        duration: 1000,
      });
    }
  };

  return (
    <Form
      actionType="UPDATE"
      data={data?.findUniqueStaff}
      id={id}
      handleUpdateUser={handleUpdateUser}
    />
  );
};

export default Update;
